import request from '../request'
const storeApis = {
    getStores: (query) => request.get(`/stores${query}`),
    createStore: (payload) => request.post('/stores', payload),
    updateStore: (payload) => request.patch(`/stores/${payload.id}`, payload.formData),
    deleteStore: (id) => request.delete(`/stores/${id}`),
    retryStore: (id) => request.patch(`/stores/${id}/retry-sync-oms`),
    defaultStore: (id) => request.patch(`stores/${id}/default`)
}
export default storeApis;